import React, { useContext, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { HelpModeContext } from "./Contexts";
import StatusTasks from "./StatusTasks";
import Box from "@mui/material/Box";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import DashboardPanelHeader from "./DashboardPanelHeader";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
} from "@syncfusion/ej2-react-grids";
import "./styles/DashboardTasks.css";

function DashboardTasks(props) {
  const [displayPage, setDisplayPage] = useState();
  const helpMode = useContext(HelpModeContext).mode;
  const today = new Date();
  //const [localWait, setLocalWait] = useState(false);
  const localWait = useRef(true);

  const customizeCell = (args) => {
    if (new Date(args.data.end) < today) {
      args.cell.classList.add("dashTaskPastCompletion");
    }
  };

  const headerTemplate = (event) => {
    return <span className="dashHeaderRow">{event.headerText}</span>;
  };
  let toolTipAnimation = {
    open: { /*effect: "ZoomIn", duration: 1000,*/ delay: 1000 },
    close: { /*effect: "ZoomOut",*/ duration: 500, delay: 0 },
  };

  useEffect(() => {
    const prepDisplayPage = props.statusVersion ? (
      <StatusTasks dataArray={props.dataArray} />
    ) : (
      <>
        <Box
          className="dashTableTitleBar"
          height="12%"
          id="__dashboardTasks_header"
          sx={{ cursor: helpMode ? "help" : "default" }}
        >
          <DashboardPanelHeader
            panelLocked={props.panelLocked}
            title="Current and Upcoming Tasks"
            removePanel={props.removePanel}
            panelId={props.panelId}
            //headerComponent={addLinkComponent}
          />
        </Box>

        <Box
          height="85%"
          id="__dashboardTasks"
          sx={{
            overflow: "auto",
            verticalAlign: "middle",
            border: "solid 2px",
            padding: "0px 4px 4px 4px",
            borderRadius: "0px 0px 6px 6px",
            backgroundColor: "white",
            position: "absolute",
            cursor: helpMode ? "help" : "default",
          }}
        >
          <TooltipComponent
            content="Uncompleted tasks with start dates in the past (Current) or in the next two weeks (Upcoming)"
            animation={toolTipAnimation}
          >
            <Backdrop
              sx={{ color: "#fff", position: "absolute", zIndex: 10 }} //, zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={
                (localWait.current &&
                  props.dataArray &&
                  props.dataArray.length > 0) ||
                false
              }
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <GridComponent
              className="gridWithSmallHeader"
              enableStickyHeader={true}
              dataSource={props.dataArray}
              queryCellInfo={customizeCell}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="name"
                  headerText="Name"
                  textAlign="Left"
                  width="55%"
                  headerTemplate={headerTemplate}
                  customAttributes={{ class: "dashTaskTitle" }}
                />
                <ColumnDirective
                  field="start"
                  headerText="Start"
                  textAlign="Center"
                  width="17%"
                  headerTemplate={headerTemplate}
                  customAttributes={{ class: "dashTaskDate" }}
                />
                <ColumnDirective
                  field="end"
                  headerText="End"
                  textAlign="Center"
                  width="17%"
                  headerTemplate={headerTemplate}
                  customAttributes={{ class: "dashTaskDate" }}
                />
                <ColumnDirective
                  field="pct"
                  headerText="Pct"
                  textAlign="Right"
                  width="10%"
                  headerTemplate={headerTemplate}
                  customAttributes={{ class: "dashTaskPercent" }}
                />
              </ColumnsDirective>
            </GridComponent>
          </TooltipComponent>
        </Box>
      </>
    );
    localWait.current = props.finished;
    setDisplayPage(prepDisplayPage);
  }, [props.dataArray, helpMode]);

  return displayPage;
}

export default DashboardTasks;

DashboardTasks.propTypes = {
  dataArray: PropTypes.array,
  individual: PropTypes.bool,
  inPanel: PropTypes.bool,
  panelLocked: PropTypes.bool,
  removePanel: PropTypes.func,
  panelId: PropTypes.number,
  finished: PropTypes.bool,
  initiateWait: PropTypes.bool,
  statusVersion: PropTypes.bool,
};
